export default class FormModal {
    /**
     *
     * @param {string} options.title
     * @param {string} options.method
     * @param {string} options.url
     * @param {string} options.size
     * @param {boolean} options.closeButton
     * @param {string} options.buttons.ok.label
     * @param {string} options.buttons.ok.className
     * @param {callback} options.buttons.ok.callback
     * @param {callback} options.buttons.ok.onSuccess
     * @param {string} options.buttons.cancel.label
     * @param {string} options.buttons.cancel.className
     * @param {callback} options.buttons.cancel.callback
     */
    constructor(options) {
        let myself = this;
        this.options = {...options};
        let closeButton = true;
        if (options.closeButton !== undefined) {
            closeButton = options.closeButton;
        }

        this.options.size = options.size || 'large';
        const defaultOkBtn = {
            label: 'Registrar',
            className: 'btn-primary'
        };
        const defaultCancelBtn = {
            label: 'Cancelar',
            className: 'btn-danger'
        }

        this.options.buttons = options.buttons || {
            ok: defaultOkBtn,
            cancel: defaultCancelBtn
        };

        this.options.buttons.cancel = this.options.buttons.cancel || defaultCancelBtn;
        this.options.buttons.ok = this.options.buttons.ok || defaultOkBtn;

        this.options.buttons.cancel.className = this.options.buttons.cancel.className || defaultCancelBtn.className;
        this.options.buttons.cancel.label = this.options.buttons.cancel.label || defaultCancelBtn.label;

        this.options.buttons.ok.className = this.options.buttons.ok.className || defaultOkBtn.className;
        this.options.buttons.ok.label = this.options.buttons.ok.label || defaultOkBtn.label;

        this.dialog = bootbox.dialog({
            title: options.title,
            message: '<p><i class="fas fa-spin fa-spinner"></i> Cargando...</p>',
            size: this.options.size,
            closeButton: closeButton,
            buttons: {
                cancel: myself.options.buttons.cancel,
                ok: {
                    label: myself.options.buttons.ok.label,
                    className: myself.options.buttons.ok.className,
                    callback: function() {
                        if (myself.options.buttons.ok.callback !== undefined) {
                            myself.options.buttons.ok.callback();
                        }
                        let jqform = myself.dialog.find('form');
                        jqform.submit();
                        return false;
                    }
                }
            }
        });
    }

    onFail(e, form) {
        let divErrores = form.querySelector('#form-errores');
        divErrores.classList.remove('d-none');
        if (e.data.errors) {
            let errores = `<div>${e.data.message}</div><ul>`;
            for (const attr in e.data.errors) {
                errores += `<li>${attr}: ${e.data.errors[attr].join('. ')}</li>`;
            }
            errores += '</ul>';
            divErrores.innerHTML = errores;
        } else {
            if (e.data.message) {
                divErrores.innerHTML = e.data.message;
            }
        }
    }

    clearErrorMessages(form) {
        let divErrores = form.querySelector('#form-errores');
        if (divErrores == null || divErrores == undefined) {
            divErrores = document.createElement('div');
            divErrores.id = 'form-errores';
            divErrores.classList.add('alert', 'alert-danger', 'd-none');
            form.appendChild(divErrores);
        } else {
            divErrores.classList.add('d-none');
            divErrores.innerHTML = '';
        }
    }

    render(html, callback) {
        let myself = this;
        this.dialog.find('.bootbox-body').html(html);
        if (callback !== undefined && callback !== null) {
            callback();
        }

        let jqform = this.dialog.find('form');
        jqform.validate({
            submitHandler: function(form) {
                myself.clearErrorMessages(form);
                let submitBtn = myself.dialog.find('.modal-footer button.btn-primary');
                let originalSubmitHtml = submitBtn.html();
                submitBtn.html('<i class="fas fa-spin fa-spinner"></i> cargando');
                submitBtn.prop('disabled', true);

                if (myself.options.method == 'POST') {
                    Ajax.post(myself.options.url, jqform.serialize(), {
                        then: function(response) {
                            if (myself.options.buttons.ok.onSuccess !== undefined) {
                                myself.options.buttons.ok.onSuccess(response);
                            }
                            myself.close();
                        },
                        always: function(response) {
                            submitBtn.html(originalSubmitHtml);
                            submitBtn.prop('disabled', false);
                        },
                        fail: function(e) {
                            myself.onFail(e, form);
                            if (myself.options.fail) {
                                myself.options.fail(e);
                            }
                        }
                    });
                } else {
                    Ajax.put(myself.options.url, jqform.serialize(), {
                        then: function(response) {
                            if (myself.options.buttons.ok.onSuccess !== undefined) {
                                myself.options.buttons.ok.onSuccess(response);
                            }
                            myself.close();
                        },
                        always: function(response) {
                            submitBtn.html(originalSubmitHtml);
                            submitBtn.prop('disabled', false);
                        },
                        fail: function(e) {
                            myself.onFail(e, form);
                            if (myself.options.fail) {
                                myself.options.fail(e);
                            }
                        }
                    });
                }
            }
        });
    }

    close() {
        this.dialog.modal('hide');
    }
}
